import { Component, OnInit, ViewEncapsulation } from '@angular/core';
import { FormBuilder, Validators } from '@angular/forms';
import { FormGroup, FormControl, NgForm, ReactiveFormsModule } from '@angular/forms';
import { Router, ActivatedRoute } from '@angular/router';
import { $DBManagerService } from '../../../../_helpers/DB/DBManager.service';
import { $ModalManagerService } from '../../../../_helpers/Modals/ModalManager.service';
import { Constants } from '../../../../_utils/Constants';
import { formatDate } from '@angular/common';
import { BsModalRef, BsModalService } from 'ngx-bootstrap/modal';
import { APIConsentService } from '../../_services/consent/API-consent';

//below code for Current Data
const now = new Date();
const currentdate = formatDate(now, 'yyyy-MM-dd', 'en-US', '+0530');

@Component({
	selector: 'consent-acquisition-scanpg',
	templateUrl: './consent-acquisition-scanpg.component.html',
	styleUrls: ['./consent-acquisition-scanpg.component.css']
})
export class ConsentAcquisitionScanPgComponent implements OnInit {

	acquisitionForm: any;
	cs_content: any;
	displayonVerify = "false"
	PEName: any;
	TemplateID: any;
	EntityID: any;
	isValid: boolean = false;
	isSubmitted: boolean = false;

	constructor(private fb: FormBuilder,
		private $modal: $ModalManagerService,
		private db: $DBManagerService,
		private _route: ActivatedRoute,
		private modalService: BsModalService,
		private cst: APIConsentService,
		private router: Router) {
		this._route.params.subscribe((params) => {
			this.PEName = this.db.get(Constants.SESSSION_STORAGE, Constants.ORG_NAME);
			this.EntityID = this.db.get(Constants.SESSSION_STORAGE, Constants.ENTITY_ID)
		});
	}
	get f() { return this.acquisitionForm.controls; }


	ngOnInit() {
		this.acquisitionForm = this.fb.group({
			pe_name: ['',],
			cstemplate_id: ['',],
			mobile_number: ['',],

		});

		this.acquisitionForm.controls['pe_name'].setValue(this.PEName);
	}

	verifyCST() {
	
		var data = {
			cst_id: this.acquisitionForm.get('cstemplate_id').value,
			entity_id: this.EntityID
		}
		
		this.cst.verifyCstID(data)
			.subscribe(r => {
				if (r.Status == "success") {
					this.displayonVerify = "true";
					this.isValid = true
					this.cs_content = r.data[0].cst_content;
					this.$modal.successModal({
						title: 'Consent Acquisition',
						msg: 'Verified successfully'
					});
				}
				else {
					alert(" Only upon Successful verification, the request can be submitted");
					this.cs_content = "";
					this.$modal.errorModal({
						title: 'Consent Acquisition',
						msg: r.Err
					});

				}
			})
	}


	//for Form submition
	onSubmit() {


			var data = {
				msisdn: this.acquisitionForm.get("mobile_number").value,
				entityid: this.EntityID,
				constempid: this.acquisitionForm.get("cstemplate_id").value,
				cstemplatecont:this.acquisitionForm.get("cstemplate_cont").value,
				source: "5"
			}

			this.cst.CSRegthruQR(data)
				.subscribe(r => {
					console.log(r)
					if (r.status == "success") {
						this.$modal.successModal({
							title: ' Consent Acquisition ',
							msg: 'Consent Acquisition Scan submitted successfully'
						})
						this.isSubmitted = true;
					}
					else {

						this.$modal.errorModal({
							title: 'Consent Acquisition',
							msg: r.err
						})
					}

				})
	
	}
}